import queryString from "query-string";
import {
  setRewardsCopy,
  updateRewardCopy,
  removeRewardCopy,
  addRewardCopy,
} from "./appifyActions";
import { privateFetch } from "apis";
import { removeEmptyParams, SecureLocalStorage } from "helpers";

// action dispatchers
export const setRewards = (rewards) => ({
  type: "SET_REWARDS",
  rewards,
});

const setReward = (reward) => ({
  type: "SET_REWARD",
  reward,
});

export const removeRewards = () => ({
  type: "REMOVE_REWARDS",
});

export const removeReward = (reward) => ({
  type: "REMOVE_REWARD",
  reward,
});

export const updateReward = (reward) => ({
  type: "UPDATE_REWARD",
  reward,
});

export const addTempReward = () => ({
  type: "ADD_TEMP_REWARD",
});
export const removeTempReward = () => ({
  type: "REMOVE_TEMP_REWARD",
});

export const updateTempReward = (reward) => ({
  type: "UPDATE_TEMP_REWARD",
  reward,
});

// API calls
export const getRewards = (appId) => (dispatch) => {
  const userId = SecureLocalStorage.getItem("userId");

  return privateFetch(
    `${__BASE_API_URL__}/userRewards?rewardsExpiredInLastXDays=100000&appId=${appId}&userId=${userId}`,
    {
      method: "GET",
    }
  )
    .then((rewards) => {
      dispatch(setRewards(rewards));
      dispatch(setRewardsCopy(rewards));
    })
    .catch((err) => {});
};

// Save a reward
export const createReward = (reward) => async (dispatch) => {
  const newReward = await postReward(reward);
  dispatch(updateTempReward(newReward));
  dispatch(addRewardCopy(newReward));
  return newReward;
};

// POST a Reward to the database
const postReward = (reward) => {
  const queryParams = queryString.stringify(reward);
  const url = __BASE_API_URL__ + `/reward?${queryParams}`;

  return privateFetch(url, {
    method: "POST",
  }).then((reward) => {
    return reward;
  });
};

// UPDATE a Reward
export const putReward = (reward) => (dispatch) => {
  const queryParams = queryString.stringify(removeEmptyParams(reward));
  const url = __BASE_API_URL__ + `/reward/${reward.id}?${queryParams}`;

  return privateFetch(url, {
    method: "PUT",
  }).then((reward) => {
    dispatch(updateReward(reward));
    dispatch(updateRewardCopy(reward));
    return reward;
  });
};

// DELETE a Reward in database
export const deleteReward = (reward) => (dispatch) => {
  const url = __BASE_API_URL__ + `/reward/${reward.id}`;

  return privateFetch(url, {
    method: "DELETE",
  }).then((res) => {
    if (res) {
      const newReward = Object.assign({}, reward);
      newReward.retired = 1;
      dispatch(updateReward(newReward));
      dispatch(updateRewardCopy(newReward));
    }
  });
};
